export default __webpack_public_path__ + "static/media/Instagram.8b30cbcf.svg";